/**
 * ShippingListPresenter
 * --
 */
import React from 'react';
import { Content, Title, Row, Col } from 'components';
import { Divider, Spin } from 'antd';

import OrderFilter from './components/OrderFilter';
import OrderSummaryStatics from '../OrderList/components/OrderSummaryStatics';

import OrderData from './components/OrderData';

const ShippingListPresenter = ({
  permission,
  loading,
  searchFilter,
  onSearch,
  orderList,
  currentShop,
  onChange,
  setCurrentShop,
  onResetFilter,
  onSaveDeliveryInfo,
  shipping_type,
  onCancel,
}) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  // 결제완료 데이터

  const { totalCount, totalPrice, totalDiscount, refundPrice, refundCount } =
    React.useMemo(() => {
      const deliveryPriceMap = new Map();
      orderList.forEach((parcel) => {
        if (!deliveryPriceMap.has(parcel.shop_order_id)) {
          deliveryPriceMap.set(
            parcel.shop_order_id,
            parcel?.shop_order?.final_delivery_price
          );
        }
      });
      const totalDeliveryPrice = Array.from(deliveryPriceMap.values()).reduce(
        (acc, cur) => acc + cur,
        0
      );
      const completedData = orderList.filter(
        (o) => !['REFUNDED', 'RETURNED'].includes(o.purchase_status)
      );
      const refundedList = orderList.filter((o) =>
        ['REFUNDED', 'RETURNED'].includes(o.purchase_status)
      );
      // 환불/취소 데이터
      const refundedData = refundedList.flatMap((order) => {
        return order.parcel_service
          ?.flatMap((parcel) => {
            //환불 있는지
            if (!parcel?.refund) return null;
            //있으면 추출
            const refund = parcel?.refund?.at(-1);
            //완료 상태 인지
            // 실제 환불이 완료된 건만 환불 집계에 포함합니다.
            if (refund?.refund_status !== 'COMPLETED') return null;
            return refund;
          })
          .filter(Boolean);
      });
      const refundCount = refundedData.length ?? 0;
      const refundPrice =
        refundedData.reduce((acc, cur) => acc + cur.payment_price ?? 0, 0) ?? 0;
      const totalCount = orderList.length ?? 0;
      const totalPrice =
        orderList.reduce((acc, cur) => acc + cur.payment_price ?? 0, 0) ?? 0;
      const totalDiscount =
        completedData.reduce(
          (acc, cur) => acc + Math.abs(cur.discount_price ?? 0),
          0
        ) ?? 0;
      return {
        totalCount,
        totalPrice: totalPrice + totalDeliveryPrice,
        totalDiscount: -totalDiscount,
        refundPrice,
        refundCount,
      };
    }, [orderList]);
  /* ===== FUNCTION ===== */
  /**
   *
   * --
   */
  const getTitle = () => {
    switch (shipping_type) {
      case 'PENDING':
        return '상품 준비중';
      case 'PREPARING':
        return '배송 준비중';
      case 'ON_HOLD':
        return '배송 보류';
      case 'SHIPPING':
        return '배송 중';
      case 'DELIVERED':
        return '배송 완료';
      case 'EXCHANGE_REQUESTED':
        return '교환 신청';
      case 'EXCHANGE_COMPLETED':
        return '교환 완료';
      case 'RETURN_REQUESTED':
        return '반품 신청';
      case 'RETURN_COMPLETED':
        return '반품 완료';
      case 'RETURN':
        return '취소/교환/반품/환불';
      default:
        return '배송 목록';
    }
  };

  /* ===== HOOKS ===== */

  /* ===== RENDER ===== */
  return (
    <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
      <Row>
        <Col x={24}>
          <Title size={3} style={{ marginBottom: 12 }}>
            {/* 배송 목록 */}
            {getTitle()}
          </Title>

          {/* 요약 */}
          <OrderFilter
            onChange={onChange}
            searchFilter={searchFilter}
            onSearch={onSearch}
            onResetFilter={onResetFilter}
            defaultShop={permission === 'ADMIN' ? null : currentShop}
            onSelect={setCurrentShop}
            permission={permission}
          />
          {/* 요약 */}
          <OrderSummaryStatics
            totalCount={totalCount ?? 0}
            totalPrice={totalPrice ?? 0}
            totalDiscount={totalDiscount ?? 0}
            refundPrice={refundPrice ?? 0}
            refundCount={refundCount ?? 0}
          />
          {/* 요약 */}
          <Spin spinning={loading}>
            <Row style={{ minHeight: '50vh' }}>
              {/* === 업체목록 === */}
              {/* {permission === 'ADMIN' && (
                <Col x={3}>
                  <ShopInformationList onChange={setCurrentShop} />
                </Col>
              )} */}
              {/* === Data === */}
              <Col
                // x={permission === 'ADMIN' ? 21 : 24}
                x={24}
                style={{
                  borderLeft: '1px solid #EBEBEB',
                }}
              >
                <OrderData
                  orderList={orderList}
                  onSaveDeliveryInfo={onSaveDeliveryInfo}
                  type={shipping_type}
                  onReload={onSearch}
                  onCancel={onCancel}
                />
              </Col>
            </Row>
          </Spin>

          <Divider />
        </Col>
      </Row>
    </Content>
  );
};

export default ShippingListPresenter;
